<script>
    import TextAttributeBase from './TextAttributeBase';

    export default {
        extends: TextAttributeBase,
        data() {
            return {
            }
        },
        computed: {
            values() {
                return _.orderBy(this.attribute.values, 'text_attribute_value.text', 'asc');
            }
        },
        methods: {
            storeValueDropdown() {
                this.storeValueData.text_attribute_value_id = this.storeValueData.text_attribute_value.id;

                if (this.storeValueData.text_attribute_context_value) {
                    this.storeValueData.text_attribute_context_value_id = this.storeValueData.text_attribute_context_value.id;
                }

                this.storeValue();
            },
            updateDropdownValue() {
                this.updateValueData.text_attribute_value_id = this.updateValueData.text_attribute_value.id;

                if (this.updateValueData.text_attribute_context_value) {
                    this.updateValueData.text_attribute_context_value_id = this.updateValueData.text_attribute_context_value.id;
                }

                this.updateValue();
            },
        },
    }
</script>

<template>
    <div :class="[withCols ? 'col-lg-8': '']">
        <div class="panel panel-default">
            <div class="panel-heading">
                <span v-html="headline"></span>
                <a class="pull-right" @click="storeValueDropdown" v-if="!isLocked && canAddAnotherValue"><i class="fa fa-save"></i></a>
                <i class="pull-right fa fa-lock" v-if="isLocked"></i>
            </div>
            <div class="panel-body">
                <div v-for="value in values" class="row m-b-sm">
                    <div v-if="isLocked">
                        <div v-if="hasContext" class="col-md-5">
                            <input readonly type="text" class="form-control" :value="value.text_attribute_context_value ? value.text_attribute_context_value.context_label : ''">
                        </div>
                        <div :class="[hasContext ? 'col-md-5': 'col-md-9']">
                            <input readonly type="text" class="form-control" :value="value.text_attribute_value.text">
                        </div>
                        <div :class="[hasContext ? 'col-md-2': 'col-md-3']">
                            <div class="input-group m-b">
                                <input readonly type="text" class="form-control text-center" :value="value.share_in_percent">
                                <span class="input-group-addon">%</span>
                            </div>
                        </div>
                    </div>
                    <Lightbox
                            v-if="!isLocked"
                            :id="lightboxId(value.id)"
                            :headline="headline"
                            :large="true"
                    >
                        <span slot="open-template" @click="selectToUpdate(value)">
                            <div v-if="hasContext" class="col-md-5">
                                <input type="text" class="form-control" :value="value.text_attribute_context_value ? value.text_attribute_context_value.context_label : ''">
                            </div>
                            <div :class="[hasContext ? 'col-md-5': 'col-md-9']">
                                <input type="text" class="form-control" :value="value.text_attribute_value.text">
                            </div>
                            <div :class="[hasContext ? 'col-md-2': 'col-md-3']">
                                <div class="input-group m-b">
                                    <input type="text" class="form-control text-center" :value="value.share_in_percent">
                                        <span class="input-group-addon">%</span>
                                </div>
                            </div>
                        </span>
                        <div slot="body" class="text-left">
                            <div class="row">
                                <div v-if="hasContext" class="col-md-5">
                                    <v-select v-model="updateValueData.text_attribute_context_value" :options="contextValues" label="context_label" class="white-bg"></v-select>
                                </div>
                                <div :class="[hasContext ? 'col-md-5': 'col-md-9']">
                                    <v-select v-model="updateValueData.text_attribute_value" :options="options" label="text" class="white-bg"></v-select>
                                </div>
                                <div :class="[hasContext ? 'col-md-2': 'col-md-3']">
                                    <div class="input-group m-b">
                                        <input type="text" class="form-control text-center" v-model="updateValueData.share_in_percent"
                                               @keyup.enter="updateDropdownValue">
                                        <span class="input-group-addon">%</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-cloak slot="footer">
                            <div class="pull-left">
                                <button type="button" class="btn btn-danger" @click="deleteValue(value.id)" v-text="__('scoop-os.common.delete')"></button>
                            </div>
                            <button type="button" class="btn btn-white" data-dismiss="modal" v-text="__('scoop-os.common.close')"></button>
                            <button class="btn btn-primary" @click="updateDropdownValue">Update</button>
                        </div>
                    </Lightbox>
                </div>
                <div v-if="!isLocked && canAddAnotherValue" class="row">
                    <div v-if="hasContext" class="col-md-5">
                        <v-select v-model="storeValueData.text_attribute_context_value" :options="contextValues" label="context_label"></v-select>
                    </div>
                    <div :class="[hasContext ? 'col-md-5': 'col-md-9']">
                        <v-select v-model="storeValueData.text_attribute_value" :options="options" label="text"></v-select>
                    </div>
                    <div :class="[hasContext ? 'col-md-2': 'col-md-3']">
                        <div class="input-group m-b">
                            <input type="text" v-model="storeValueData.share_in_percent" class="form-control text-center"
                                   @keyup.enter="storeValueDropdown">
                            <span class="input-group-addon">%</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>